/* Practiko: precio aproximado en colones junto al precio en dólares (referencia; el cobro es en USD) */
(function(){
  var RATE = 440;
  function usd(t){ var m=(t||'').replace(/,/g,'').match(/\d+(?:\.\d+)?/); return m?parseFloat(m[0]):null; }
  function crcNum(v){ var n=Math.round(v*RATE/100)*100; return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
  function priceEl(box){
    return box.querySelector('.price__sale:not(.price__hidden) .price-item--sale') || box.querySelector('.price__regular:not(.price__hidden) .price') || box.querySelector('.price');
  }
  function setText(n, num){
    var t = '\u20A1' + num;
    if (n.textContent !== t) { n.textContent = t; n.setAttribute('aria-label', 'aproximadamente ' + num + ' colones'); n.title = 'Aproximado en colones (\u20A1' + RATE + ' por d\u00F3lar)'; }
  }
  function run(){
    document.querySelectorAll('[ref="priceContainer"]').forEach(function(box){
      if (box.closest('.sticky-add-to-cart__price')) return;
      var el = priceEl(box); var v = el && usd(el.textContent); if (!v) return;
      box.querySelectorAll('.pk-crc').forEach(function(x){ if (x.nextElementSibling !== el) x.remove(); });
      box.querySelectorAll('.pk-usd-2').forEach(function(x){ if (x !== el) x.classList.remove('pk-usd-2'); });
      var n = el.previousElementSibling;
      if (!n || !n.classList.contains('pk-crc')) { n = document.createElement('span'); n.className = 'pk-crc pk-crc--first'; el.insertAdjacentElement('beforebegin', n); }
      if (!el.classList.contains('pk-usd-2')) el.classList.add('pk-usd-2');
      var s = getComputedStyle(el);
      if (n.style.fontSize !== s.fontSize) n.style.fontSize = s.fontSize;
      if (n.style.fontFamily !== s.fontFamily) n.style.fontFamily = s.fontFamily;
      if (n.style.lineHeight !== s.lineHeight) n.style.lineHeight = s.lineHeight;
      setText(n, crcNum(v));
    });
    document.querySelectorAll('.cart-totals__total').forEach(function(t){
      var el = t.querySelector('.cart-totals__total-value'); var v = el && usd(el.textContent); if (!v) return;
      var n = t.nextElementSibling;
      if (!n || !n.classList.contains('pk-crc')) { n = document.createElement('div'); n.className = 'pk-crc pk-crc--cart'; t.insertAdjacentElement('afterend', n); }
      var s = getComputedStyle(el); if (n.style.fontSize !== s.fontSize) n.style.fontSize = s.fontSize; if (n.style.fontFamily !== s.fontFamily) n.style.fontFamily = s.fontFamily; if (n.style.fontWeight !== s.fontWeight) n.style.fontWeight = s.fontWeight;
      setText(n, crcNum(v));
    });
  }
  var q = false;
  function sched(){ if (q) return; q = true; requestAnimationFrame(function(){ q = false; run(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(sched).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-pk-copy]'); if (!b) return;
    var t = b.getAttribute('data-pk-copy'), old = b.textContent;
    function done(){ b.textContent = 'N\u00FAmero copiado'; setTimeout(function(){ b.textContent = old; }, 1800); }
    if (navigator.clipboard) navigator.clipboard.writeText(t).then(done, done); else done();
  });
})();
